import React, { useState, useEffect } from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    FormControlLabel,
    Checkbox,
    IconButton,
    Typography,
    Box,
    Grid,
    Chip,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ScaleIcon from '@mui/icons-material/Scale';
import StraightenIcon from '@mui/icons-material/Straighten';
import Paper from '@mui/material/Paper';
// We'll use a hardcoded mapping for now since we can't import from backend
const testBooksMapping = {
    "Heavy Construction": [
        "Codes of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "International Building Code, 2018",
        "Storm Water Management for Construction Activities, 1992 – EPA",
        "Pipe and Excavation Contracting – Dave Roberts, 2011",
        "Design and Control of Concrete Mixtures, 15th or 16th Edition – Steven H. Kosmatka",
        "Placing Reinforcing Bars, Recommended Practices, 2011 or later, 9th edition",
        "Erectors' Manual – Standards and Guidelines for the Erection of PreCast Concrete Products – 2nd Edition",
        "Construction Planning, Equipment, and Methods, 8th Edition – R.L. Peurifoy"
    ],
    "Highways, Streets, & Bridges": [
        "Codes of Federal Regulations – 29 CFR Part 1926 – OSHA – PSI Selections",
        "Construction Planning, Equipment, and Methods, 6th Edition – R.L. Peurifoy",
        "Pipe and Excavation Contracting, 2011 – Dave Roberts",
        "Design and Control of Concrete Mixtures, 16th Edition – Steven H. Kosmatka",
        "Hot-Mix Asphalt Paving Handbook (MAPH-2) 2000",
        "Placing Reinforcing Bars, Recommended Practices, 2011 or later, 9th Edition",
        "Instructional Manual for Training and Certification of Field Personnel for Unbonded Post-Tensioning, 3rd Edition, 2003",
        "Jacked Tunnel Design and Construction, 1998 – Marco D. Boscardin",
        "Storm Water Management for Construction Activities, 1992 – EPA",
        "Manual on Uniform Traffic Control Devices for Streets and Highways, 2009 – US Dept. of Transportation"
    ],
    "Electrical – State Wide": [
        "Code of Federal Regulations – 29 CFR Part 1926 – PSI Selections",
        "NFPA 70 – National Electrical Code, 2023 Edition",
        "Ugly's Electrical References, 2011, 2014, or 2017 – George V. Hart"
    ],
    "Roofing, Sheetmetal, & Siding": [
        "International Building Code, 2018",
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "International Residential Code for One- and Two-Family Dwellings, 2018 Edition",
        "Roofing Construction & Estimating, 1995 – Daniel Atcheson",
        "NRCA Roofing Manual: Steep Slope Roof Systems, 2017",
        "NRCA Roofing Manual: Membrane Roofing Systems, 2017"
    ],
    "Residential": [
        "International Residential Code, 2018 Edition",
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "The Contractor's Guide to Quality Concrete Construction, 4th Edition",
        "Modern Masonry – Brick, Block, Stone – 8th Edition (2015)",
        "Carpentry and Building Construction, 2010 or 2016 - John L. Feirer",
        "BCSI: Guide to Good Practice for Handling, Installing, Restraining, and Bracing of Metal Plate Connected Wood Trusses, 2018",
        "Pipe and Excavation Contracting, 2011 – Dave Roberts",
        "Roofing Construction & Estimating, 1995 – Daniel Atcheson"
    ],
    "Building Construction": [
        "International Building Code, 2018",
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "Technical Digest No. 9 – Handling and Erection of Steel Joists and Joist Girders, 3rd Edition, 2008",
        "Carpentry and Building Construction, 2010 or 2016 – John L. Feirer",
        "Design and Control of Concrete Mixtures, 15th or 16th Edition, 2016 – Steven H. Kosmatka",
        "Pipe and Excavation Contracting, 2011 – Dave Roberts",
        "Roofing Construction & Estimating, 1995 – Daniel Atcheson",
        "Training and Certification of Field Personnel for Unbonded Post-Tensioning, 2003, 3rd Edition",
        "Modern Masonry – Brick, Block, Stone, 8th Edition, 2015 – Clois E. Kicklighter",
        "Placing Reinforcing Bars, Recommended Practices, 2011 or later printing, 9th edition"
    ],
    "Municipal and Public Works": [
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "Storm Water Management for Construction Activities, 1992 – EPA",
        "Lineman's and Cableman's Handbook, 13th or 14th Edition – Shoemaker and Mack",
        "Installation Guide for Ductile Iron Pipe, 2015 w/ latest updates",
        "Modern Welding, 11th Edition",
        "Design and Control of Concrete Mixtures, 17th Edition, 2021 – Steven H. Kosmatka",
        "Pipe and Excavation Contracting, 2011 – Dave Roberts"
    ],
    "Mechanical": [
        "Codes of Federal Regulation – 29 CPR Part 1926 (OSHA) – PSI Selections",
        "Modern Refrigeration and Air Conditioning, 20th Edition – Althouse, Turnquist",
        "International Fuel Gas Code, 2018",
        "HVAC Duct Construction Standards, Metal and Flexible, 2005, 3rd Edition",
        "Manual N – Load Calculation for Small Commercial Buildings, 5th Edition, 2008",
        "International Mechanical Code, 2018",
        "International Plumbing Code, 2018",
        "NFPA 58: Liquified Petroleum Gas Code, 2011 Edition",
        "NFPA 13: Installation of Sprinkler Systems, 2002",
        "ACCA Ductulator, Air Conditioning Contractors of America",
        "Manual D, 2016, 4th Edition",
        "Pipefitters Handbook, 3rd Edition, 1967 – Forrest R. Lindsey"
    ],
    "Steel Erection and Installation": [
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "2021 International Building Code",
        "Technical Digest No. 9 – Handling and Erection of Steel Joists and Joist Girders, 3rd Edition, 2008",
        "Code of Standard Practice for Steel Buildings and Bridges",
        "Modern Welding, 11th Edition, 2013",
        "Manual of Steel Construction, 15th Edition"
    ],
    "Masonry, Brick, & Stone": [
        "International Building Code, 2018",
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "Modern Masonry – Brick, Block, Stone, 8th Edition – Clois E. Kicklighter",
        "Indiana Limestone Handbook, 22nd Edition, 2007",
        "Repointing Mortar Joints in Historic Masonry Buildings – Robert C. Mack"
    ],
    "Foundations & Pile Driving": [
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "International Building Code, 2018",
        "Design and Control of Concrete Mixtures, 2011 or 2016 – Steven H. Kosmatka",
        "Construction Planning, Equipment, and Methods – Robert L. Peurifoy",
        "Pipe and Excavation Contracting, 1987 or 2011 – Dave Roberts",
        "Soils and Foundations, 2008. 7th Edition – Cheng Liu",
        "Formwork for Concrete, 2005 or 2015 – M.K. Hurd"
    ],
    "Concrete Construction Excluding Highways, Streets, Bridges": [
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "SP-4 Formwork for Concrete, 2014, 8th Edition – David W. Johnston",
        "Design and Control of Concrete Mixtures, 16th Edition, 2016 – Steven H. Kosnatka",
        "Sawcutting Joints in Concrete, 1995 – Bruce A. Suprenant",
        "Sawcutting Concrete Flatwork, 1994 – Rosalie Johnston",
        "Taking the Tedium Out of Cutting, 1981",
        "Tips for Cutting Concrete, 1987",
        "International Building Code, 2018"
    ],
    "Earthwork, Drainage, and Levees": [
        "Code of Federal Regulations – 29 CFR Part 1926 (OSHA) – PSI Selections",
        "Louisiana 811 – We can print this ourselves, only 2 pages",
        "Design and Control of Concrete Mixtures, 16th Edition – Steven H. Kosmatka",
        "Pipe and Excavation Contracting, 2011 – Dave Roberts",
        "Design and Construction of Urban Storm Water Management Systems, 1992"
    ]
};

const PurchaseOptionsManager = ({ open, onClose, product, onSave }) => {
    const [purchaseOptions, setPurchaseOptions] = useState([]);
    const [editingBook, setEditingBook] = useState({ optionIndex: null, bookIndex: null, value: '' });
    const [shippingInfo, setShippingInfo] = useState({
        weight: 0,
        dimensions: {
            length: 12,
            width: 12,
            height: 12
        }
    });

    useEffect(() => {
        // Initialize shipping info from product
        if (product?.bookPackageInfo) {
            setShippingInfo({
                weight: product.bookPackageInfo.weight || 0,
                dimensions: {
                    length: product.bookPackageInfo.dimensions?.length || 12,
                    width: product.bookPackageInfo.dimensions?.width || 12,
                    height: product.bookPackageInfo.dimensions?.height || 12
                }
            });
        }
        
        if (product?.purchaseOptions && product.purchaseOptions.length > 0) {
            setPurchaseOptions(product.purchaseOptions);
        } else {
            // Initialize with default options
            const testBooks = testBooksMapping[product?.name] || [];
            const studyPrice = product?.price || 475;
            const baseBookPrice = product?.bookPackageInfo?.cost || 1425; // Base book cost
            const booksOnlyPrice = Math.round(baseBookPrice * 1.25); // 25% markup for books only
            const completePrice = studyPrice + baseBookPrice; // Complete package = study + base book price (no markup)
            setPurchaseOptions([
                {
                    optionType: 'studyProgramOnly',
                    displayName: 'Study Program Only',
                    price: studyPrice,
                    isTaxable: false,
                    books: []
                },
                {
                    optionType: 'studyProgramWithBooks',
                    displayName: 'Study Program with Books',
                    price: completePrice,
                    isTaxable: true,
                    books: testBooks
                },
                {
                    optionType: 'booksOnly',
                    displayName: 'Books Only',
                    price: booksOnlyPrice,
                    isTaxable: true,
                    books: testBooks
                }
                // Rent books option hidden for future implementation
                // {
                //     optionType: 'studyProgramAndRentBooks',
                //     displayName: 'Study Program and Rent Books',
                //     price: 875,
                //     isTaxable: true,
                //     books: testBooks
                // }
            ]);
        }
    }, [product]);

    const handlePriceChange = (index, newPrice) => {
        const updated = [...purchaseOptions];
        updated[index].price = parseFloat(newPrice) || 0;
        setPurchaseOptions(updated);
    };

    const handleTaxableChange = (index, isTaxable) => {
        const updated = [...purchaseOptions];
        updated[index].isTaxable = isTaxable;
        setPurchaseOptions(updated);
    };

    const handleDisplayNameChange = (index, displayName) => {
        const updated = [...purchaseOptions];
        updated[index].displayName = displayName;
        setPurchaseOptions(updated);
    };

    const handleAddBook = (optionIndex) => {
        const newBook = prompt('Enter book title:');
        if (newBook) {
            const updated = [...purchaseOptions];
            updated[optionIndex].books.push(newBook);
            setPurchaseOptions(updated);
        }
    };

    const handleEditBook = (optionIndex, bookIndex) => {
        setEditingBook({
            optionIndex,
            bookIndex,
            value: purchaseOptions[optionIndex].books[bookIndex]
        });
    };

    const handleSaveBook = () => {
        if (editingBook.optionIndex !== null && editingBook.bookIndex !== null) {
            const updated = [...purchaseOptions];
            updated[editingBook.optionIndex].books[editingBook.bookIndex] = editingBook.value;
            setPurchaseOptions(updated);
            setEditingBook({ optionIndex: null, bookIndex: null, value: '' });
        }
    };

    const handleDeleteBook = (optionIndex, bookIndex) => {
        const updated = [...purchaseOptions];
        updated[optionIndex].books.splice(bookIndex, 1);
        setPurchaseOptions(updated);
    };

    const handleSave = () => {
        onSave(purchaseOptions, shippingInfo);
        onClose();
    };

    const getOptionTitle = (option) => {
        switch (option.optionType) {
            case 'studyProgramOnly':
                return 'Option A: Study Program Only';
            case 'studyProgramWithBooks':
                return 'Option B: Study Program with Books';
            case 'booksOnly':
                return 'Option C: Books Only';
            case 'studyProgramAndRentBooks':
                return 'Option D: Study Program and Rent Books';
            default:
                return option.displayName;
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>
                Manage Purchase Options - {product?.name}
            </DialogTitle>
            <DialogContent>
                {/* Editable Shipping Information */}
                <Paper elevation={0} sx={{ 
                    p: 2, 
                    mb: 2,
                    backgroundColor: '#f0f7ff',
                    borderRadius: 2,
                    border: '1px solid #1976d2'
                }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                        <LocalShippingIcon sx={{ mr: 1, color: '#1976d2' }} />
                        <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                            Shipping Information
                        </Typography>
                    </Box>
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label="Weight (lbs)"
                                type="number"
                                value={shippingInfo.weight}
                                onChange={(e) => setShippingInfo({
                                    ...shippingInfo,
                                    weight: parseFloat(e.target.value) || 0
                                })}
                                InputProps={{
                                    startAdornment: <ScaleIcon sx={{ mr: 1, fontSize: 18, color: '#666' }} />,
                                    inputProps: { min: 0, step: 0.1 }
                                }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label="Length (inches)"
                                type="number"
                                value={shippingInfo.dimensions.length}
                                onChange={(e) => setShippingInfo({
                                    ...shippingInfo,
                                    dimensions: {
                                        ...shippingInfo.dimensions,
                                        length: parseFloat(e.target.value) || 0
                                    }
                                })}
                                InputProps={{
                                    inputProps: { min: 0, step: 0.1 }
                                }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label="Width (inches)"
                                type="number"
                                value={shippingInfo.dimensions.width}
                                onChange={(e) => setShippingInfo({
                                    ...shippingInfo,
                                    dimensions: {
                                        ...shippingInfo.dimensions,
                                        width: parseFloat(e.target.value) || 0
                                    }
                                })}
                                InputProps={{
                                    inputProps: { min: 0, step: 0.1 }
                                }}
                                size="small"
                            />
                        </Grid>
                        <Grid item xs={12} sm={3}>
                            <TextField
                                fullWidth
                                label="Height (inches)"
                                type="number"
                                value={shippingInfo.dimensions.height}
                                onChange={(e) => setShippingInfo({
                                    ...shippingInfo,
                                    dimensions: {
                                        ...shippingInfo.dimensions,
                                        height: parseFloat(e.target.value) || 0
                                    }
                                })}
                                InputProps={{
                                    inputProps: { min: 0, step: 0.1 }
                                }}
                                size="small"
                            />
                        </Grid>
                    </Grid>
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
                        These shipping details apply to all book packages
                    </Typography>
                </Paper>
                
                <Box sx={{ mt: 2 }}>
                    {purchaseOptions.map((option, index) => (
                        <Accordion key={index} defaultExpanded>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Typography variant="h6">
                                    {getOptionTitle(option)}
                                    <Chip 
                                        label={`$${option.price}`} 
                                        color="primary" 
                                        size="small" 
                                        sx={{ ml: 2 }}
                                    />
                                    {option.isTaxable && (
                                        <Chip 
                                            label="Taxable" 
                                            color="secondary" 
                                            size="small" 
                                            sx={{ ml: 1 }}
                                        />
                                    )}
                                </Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Display Name"
                                            value={option.displayName}
                                            onChange={(e) => handleDisplayNameChange(index, e.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <TextField
                                            fullWidth
                                            label="Price"
                                            type="number"
                                            value={option.price}
                                            onChange={(e) => handlePriceChange(index, e.target.value)}
                                            InputProps={{
                                                startAdornment: '$',
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    checked={option.isTaxable}
                                                    onChange={(e) => handleTaxableChange(index, e.target.checked)}
                                                    disabled={option.optionType === 'studyProgramOnly'}
                                                />
                                            }
                                            label="Taxable"
                                        />
                                    </Grid>
                                    
                                    {(option.optionType === 'studyProgramWithBooks' || 
                                      option.optionType === 'studyProgramAndRentBooks' ||
                                      option.optionType === 'booksOnly') && (
                                        <Grid item xs={12}>
                                            <Box sx={{ mt: 2 }}>
                                                <Typography variant="subtitle1" gutterBottom>
                                                    Books Included ({option.books.length})
                                                    <IconButton 
                                                        size="small" 
                                                        onClick={() => handleAddBook(index)}
                                                        color="primary"
                                                    >
                                                        <AddIcon />
                                                    </IconButton>
                                                </Typography>
                                                <List dense>
                                                    {option.books.map((book, bookIndex) => (
                                                        <ListItem key={bookIndex}>
                                                            {editingBook.optionIndex === index && 
                                                             editingBook.bookIndex === bookIndex ? (
                                                                <TextField
                                                                    fullWidth
                                                                    value={editingBook.value}
                                                                    onChange={(e) => setEditingBook({
                                                                        ...editingBook,
                                                                        value: e.target.value
                                                                    })}
                                                                    onBlur={handleSaveBook}
                                                                    onKeyPress={(e) => {
                                                                        if (e.key === 'Enter') {
                                                                            handleSaveBook();
                                                                        }
                                                                    }}
                                                                    autoFocus
                                                                />
                                                            ) : (
                                                                <>
                                                                    <ListItemText 
                                                                        primary={book}
                                                                        primaryTypographyProps={{
                                                                            variant: 'body2'
                                                                        }}
                                                                    />
                                                                    <ListItemSecondaryAction>
                                                                        <IconButton 
                                                                            edge="end" 
                                                                            size="small"
                                                                            onClick={() => handleEditBook(index, bookIndex)}
                                                                        >
                                                                            <EditIcon fontSize="small" />
                                                                        </IconButton>
                                                                        <IconButton 
                                                                            edge="end" 
                                                                            size="small"
                                                                            onClick={() => handleDeleteBook(index, bookIndex)}
                                                                        >
                                                                            <DeleteIcon fontSize="small" />
                                                                        </IconButton>
                                                                    </ListItemSecondaryAction>
                                                                </>
                                                            )}
                                                        </ListItem>
                                                    ))}
                                                </List>
                                            </Box>
                                        </Grid>
                                    )}
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button onClick={handleSave} variant="contained" color="primary">
                    Save Options
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default PurchaseOptionsManager;